<template>
    <div class="login-wrap">
        <p class="login-title">需要登录</p>
        <p class="login-hint">请使用公司 @bidderdesk.com 的 Google 账号</p>
        <div id="button" class="login-button-host"></div>
    </div>
</template>

<script>
export default {
    name: "Login",
    mounted() {
        const el = this.$el.querySelector('#button');
        const g = window.google;
        if (el && g && g.accounts && g.accounts.id) {
            g.accounts.id.renderButton(el, {type: 'standard', theme: 'outline', size: 'large'});
        }
    }
}
</script>

<style scoped>
.login-wrap {
    position: fixed;
    z-index: 10000;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    min-width: 320px;
    padding: 28px 32px 24px;
    text-align: center;
    background: var(--el-bg-color, #fff);
    border: 1px solid var(--el-border-color, #e4e7ed);
    border-radius: 10px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}
.login-title {
    margin: 0 0 8px;
    font-size: 18px;
    font-weight: 600;
    color: var(--el-text-color-primary, #303133);
}
.login-hint {
    margin: 0 0 20px;
    font-size: 13px;
    line-height: 1.5;
    color: var(--el-text-color-secondary, #909399);
}
.login-button-host {
    display: flex;
    justify-content: center;
}
</style>